/**
 * Doomsworn — conditions
 *
 * The 5e condition set is kept verbatim so Open5e statblocks, token overlays
 * and combat code keep working unchanged — with one deletion: there is no
 * `concentrating`, because there is no concentration in this system.
 *
 * Added on top: the marks this world leaves on people. Wear, Liens, Grip and
 * Callings are engine-owned records, surfaced as conditions so the GM sees
 * them every scene.
 */
export const DOOMSWORN_CONDITIONS = [
    // --- Kept from the d20 engine, unchanged ---
    { id: 'blinded', name: 'Blinded', description: 'Cannot see. Auto-fail sight checks. Attacks have disadvantage, attacks against have advantage.', hasLevels: false },
    { id: 'charmed', name: 'Charmed', description: 'Cannot attack or target the charmer with harmful effects. Charmer has advantage on social checks.', hasLevels: false },
    { id: 'deafened', name: 'Deafened', description: 'Cannot hear. Auto-fail hearing checks.', hasLevels: false },
    { id: 'frightened', name: 'Frightened', description: 'Disadvantage on checks and attacks while the source is in line of sight. Cannot willingly move closer.', hasLevels: false },
    { id: 'grappled', name: 'Grappled', description: 'Speed becomes 0. Ends if the grappler is incapacitated or forced apart.', hasLevels: false },
    { id: 'incapacitated', name: 'Incapacitated', description: 'Cannot take actions.', hasLevels: false },
    { id: 'invisible', name: 'Invisible', description: 'Cannot be seen unaided. Attacks have advantage, attacks against have disadvantage.', hasLevels: false },
    { id: 'paralyzed', name: 'Paralyzed', description: 'Incapacitated, cannot move or speak. Auto-fail STR/DEX saves. Melee hits are critical.', hasLevels: false },
    { id: 'petrified', name: 'Petrified', description: 'Turned to stone. Incapacitated, resistant to all damage, immune to poison and disease.', hasLevels: false },
    { id: 'poisoned', name: 'Poisoned', description: 'Disadvantage on attack rolls and ability checks.', hasLevels: false },
    { id: 'prone', name: 'Prone', description: 'Disadvantage on attacks. Melee attacks against have advantage, ranged have disadvantage.', hasLevels: false },
    { id: 'restrained', name: 'Restrained', description: 'Speed 0. Attacks have disadvantage, attacks against have advantage. Disadvantage on DEX saves.', hasLevels: false },
    { id: 'stunned', name: 'Stunned', description: 'Incapacitated, cannot move, speaks falteringly. Auto-fail STR/DEX saves.', hasLevels: false },
    { id: 'unconscious', name: 'Unconscious', description: 'Incapacitated and unaware. Drop everything, fall prone. Auto-fail STR/DEX saves. Melee hits are critical.', hasLevels: false },
    { id: 'exhaustion', name: 'Exhaustion', description: 'Cumulative fatigue. Level 6 is death.', hasLevels: true, maxLevel: 6 },
    { id: 'bloodied', name: 'Bloodied', description: 'At or below half hit points. Narration aid, not a rules trigger.', hasLevels: false },
    // --- Doomsworn additions: what the world spends of you ---
    {
        id: 'wear',
        name: 'Wear',
        description: 'Permanent marks carried alongside HP, accrued from Doom Clock thresholds, Liens, rune Grip and lost will-contests. ' +
            'Small mechanically, large narratively: Wear is what the GM describes about you. HP comes back. Wear does not.',
        hasLevels: true,
    },
    {
        id: 'lien',
        name: 'Lien',
        description: 'A concrete claim a Power holds over you, written into the sheet by the engine — "your left hand belongs to Kethrem", ' +
            '"you cannot lie inside a temple", "one memory, each new moon". Each level is one active claim. The GM plays them; ' +
            'the GM cannot forgive them.',
        hasLevels: true,
    },
    {
        id: 'grip',
        name: 'Grip',
        description: 'How deeply a rune has taken hold. Rises on every successful rune action. Marks at 3, 6 and 9; from 8 the rune begins ' +
            'acting without you; at 10 you stop being a person and become a local law of nature.',
        hasLevels: true,
        maxLevel: 10,
    },
    {
        id: 'called',
        name: 'Called',
        description: 'A Power has issued a Calling and is waiting. Refusal escalates: Attunement toward that Power inverts and its existing ' +
            'gifts begin acting on their own initiative.',
        hasLevels: false,
    },
    {
        id: 'doom-near',
        name: 'Doom Near',
        description: 'The Doom Clock is past its last threshold. The declared Doom is arriving, and the GM should be foreshadowing it in ' +
            'every scene — in the weather, in what NPCs notice, in what the world offers.',
        hasLevels: false,
    },
];
//# sourceMappingURL=conditions.js.map